import PaqueteTodoFacilController from '../controllers/PaqueteTodoFacilController';
import { getDataBase } from '../db';

export default class CategoriaDAL{

    //emtodo GetConsumoMinimo
    async GetConsumoMinimo(tnCategoria, DataBaseAlias){
        try {   
            const db = await getDataBase();
            const tx = db.transaction('CATEGORIA', 'readonly');
            const store = tx.objectStore('CATEGORIA');
            const laCategorias = await store.getAll(Number(tnCategoria));
            await tx.done;
            // return laCategorias[0].ConsumoMinimo;
            return laCategorias;
        } catch (error) {
            
            return [];
        }
        
    }

}
